import { createI18nInstance } from '@ccm-innovation/i18n';
import { enUs } from './locales/en-US';
import { esUs } from './locales/es-US';

export const resources = {
  'en-US': enUs,
  'es-US': esUs,
} as const;

export type Locale = keyof typeof resources;

export const { i18n, I18nProvider, useTranslation } = createI18nInstance({
  debug: false,
  initialLocale: 'en-US',
  resources,
});

export type RenderTransFunction = ReturnType<
  typeof useTranslation
>['renderTrans'];
export type TFunction = ReturnType<typeof useTranslation>['t'];
